import React from 'react';
import styled from 'styled-components';
import { BoardExtendedData } from '../../../api/ApiTypes';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { Badge } from '../../../ui/Badge';
import { Divider, Flexer, LinkButton } from '../../dashboard/elements/LayoutElements';

export type BoardInfoButtonProps = {
    board?: BoardExtendedData,
};

const ItemHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    color: ${Colors.text};
    font-size: 1.125rem;
    font-weight: 450;
    white-space: nowrap;
`;

const ItemBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: .25rem;
    color: ${Colors.textLight};
    font-size: .875rem;
`;

export const BoardInfoView = ({ board }: BoardInfoButtonProps) => {

    const path = board.workspace
        ? [board.workspace.label, board.folder?.label].filter(Boolean)
        : null;

    return <Flexer padding=".5">
        <Flexer flex="row" gap=".5" padding=".5 2 .5 .5">
            <Icon size="1.5" src="deqo://icons/dash/board" />
            <Flexer flex="column" gap=".5">
                <ItemHeader>
                    <span>{board.label}</span>
                    <Badge color={Colors.gray100}>
                        {board.id}
                    </Badge>
                </ItemHeader>
                <ItemBody>
                    {path && <span>in {path.join(' / ')}</span>}
                    {!path && <span>Archived</span>}
                    <span>Created by {board?.user?.name ?? 'Unknown'}</span>
                    <span>Created on {board.createdAt.toISOString()}</span>
                </ItemBody>
            </Flexer>
        </Flexer>
        <Divider mode="horizontal" margin=".5 0" />
        <Flexer flex="row" justify="end">
            <LinkButton size="sm" target="_blank" href={`/${board.id}`}>
                Open Board
                <Icon size="1" src="deqo://icons/hero/external-link" />
            </LinkButton>
        </Flexer>
    </Flexer>;
};
